import axios from 'axios'
import { get } from 'svelte/store'
import { find, isEmpty } from 'lodash'
import { user_font_tags, user_font_tags_loading_state, detected_fonts, server_path, local_fonts } from '../stores'

export async function loadTags() {
  console.log('Tags - loading tags')
  
  try {
    // Fetch tagged fonts from server
    const response = await axios.get(get(server_path) + 'tags/get.php', { withCredentials: true })
    
    if (response.data && response.data.success) {
      console.log('Tags - fetched successfully')
      
      // Set to store
      user_font_tags.set(response.data.data || [])
      
      // Set loading state to success
      user_font_tags_loading_state.setSuccess()
      
      // Map tags to fonts
      mapTagsDataToFonts(response.data.data || [])
      
    } else {
      user_font_tags_loading_state.setError(response.data.error || 'Unknown error')
    }
  } catch (error) {
    user_font_tags_loading_state.setError('Network error')
    console.error('Error loading tags:', error)
  }
}

// Map user tags to fonts in the detected fonts store
export function mapTagsDataToFonts(tag_data) {
  let local_fonts_loaded = !isEmpty(get(local_fonts));
  
  for (let i = 0; i < tag_data.length; i++) {
    const tagged_fonts = tag_data[i]
    const tagid = tagged_fonts.id
    const tagged_fonts_array = tagged_fonts.fonts.split('|-|')

    for (let j = 0; j < tagged_fonts_array.length; j++) {
      const tagged_font = tagged_fonts_array[j]
      let found_font = find(get(detected_fonts), (f) => f.postscript_name === tagged_font)
      if (!found_font && local_fonts_loaded) {
        found_font = find(get(detected_fonts), (f) => f.display_name === tagged_font) || find(get(detected_fonts), (f) => f.family_name === tagged_font)
      } 
      if(found_font) {
        if(!found_font.tags) { found_font.tags = [] }
        found_font.tags = [...found_font.tags, tagid]
        found_font.tagged = true
      }
    }
  }
  detected_fonts.set(get(detected_fonts))
  console.log('Tags - mapped tags to fonts')
}

// Reload tagged fonts by resetting and fetching them
export async function reloadTagedFonts() {
  // Reset detected font tags
  get(detected_fonts).forEach(f => {
    f.tags = undefined
    f.tagged = false
  })
  console.log('Tags - reset all tags in fonts')
  // load tags
  try {
    await loadTags()
  } catch (error) {
    console.error('Error reloading tagged fonts:', error)
  }
}

// Save or update a tag
export async function saveTag(formData) {
  return axios.post(get(server_path) + 'tags/save.php', formData, {withCredentials: true})
}

// Delete a tag
export async function deleteTag(tagId) {
  const formData = new FormData()
  formData.append('tag_id', tagId)
  return axios.post(get(server_path) + 'tags/delete.php', formData, {withCredentials: true})
}